import type Alpine from "alpinejs";

interface SliderData {
  index: number;
  count: number;
  timer: ReturnType<typeof setInterval> | null;
  init(): void;
  start(): void;
  stop(): void;
  go(dir: number): void;
  set(idx: number): void;
}

export function registerSlider(A: typeof Alpine) {
  A.data(
    "momaSlider",
    (count: number = 1, intervalMs: number = 6000): SliderData => ({
      index: 0,
      count,
      timer: null,
      init() {
        const reduced = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        if (this.count > 1 && !reduced) this.start();
      },
      start() {
        this.stop();
        this.timer = setInterval(() => this.go(1), intervalMs);
      },
      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      },
      go(dir: number) {
        this.index = (this.index + dir + this.count) % this.count;
      },
      set(idx: number) {
        this.index = ((idx % this.count) + this.count) % this.count;
      },
    }),
  );
}
